import { gql, TypedDocumentNode } from "@apollo/client";

import {
  PatientApprovedNotesQuery,
  PatientApprovedNotesQueryVariables,
} from "./GetPatientsApprovedNotes.generated";
import { NOTE_FIELDS } from "../fragments/note";

const GET_PATIENTS_APPROVED_NOTES: TypedDocumentNode<
  PatientApprovedNotesQuery,
  PatientApprovedNotesQueryVariables
> = gql`
  ${NOTE_FIELDS}
  query patientApprovedNotes(
    $uuid: String
    $isApproved: Boolean
    $last: Boolean
  ) {
    patient(uuid: $uuid) {
      uuid
      createdAt
      name
      lastNameOfOwner
      user {
        uuid
        firstName
        lastName
        name
        account {
          uuid
          accountType
          logoFileLink
          headerInfoPdf
        }
      }
      notes(isApproved: $isApproved, last: $last) {
        user {
          uuid
          firstName
          lastName
        }
        autoTemplates {
          uuid
          name
        }
        ...NoteFields
        keyHistory
        keyMedications
        vaccinationStatus
      }
    }
  }
`;
export default GET_PATIENTS_APPROVED_NOTES;
